import 'slick-carousel/slick/slick'

export default class HomepageHeroSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-home-hero-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 3,
                slidesToScroll: 1,
                appendDots: $('.js-home-hero-slider-dots'),
                arrows: false,
                dots: true,
                infinite: false,

                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        }

    }

};

new HomepageHeroSlider();